module.exports = __webpack_public_path__ + "static/media/grit-leadership-logo-white.4442de71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grit-leadership-logo-white.svg
// module id = 6962
// module chunks = 2